/*
 * @Author: Src
 * @Date: 2026-01-28 09:02:10
 * @LastEditTime: 2026-01-28 14:22:27
 * @LastEditors: Src
 * @FilePath: /work-station/src/directives/draggable.ts
 * @Description: 拖拽指令
 * @usage:  v-draggable="handleDragReset"  handleDragReset 是回调函数，用于重置拖拽状态
 * @Copyright (c) 2026 by Src, All Rights Reserved.
 */

import Vue from 'vue';

interface DragState {
  isDragging: boolean;
  offsetX: number;
  offsetY: number;
  modalEl: HTMLElement | null;
  headerEl: HTMLElement | null;
}

const draggable = Vue.directive('draggable', {
  bind(el: HTMLElement, binding: any) {
    // el 是 a-modal 的 wrapper（即 .ant-modal-wrap）
    // 我们需要找到 .ant-modal 和 .ant-modal-header
    let modalEl: any = null;
    let headerEl: any = null;

    const findElements = () => {
      modalEl = el.querySelector('.ant-modal') as HTMLElement | null;
      headerEl = modalEl?.querySelector('.ant-modal-header') as HTMLElement | null;
    };

    findElements();

    if (!headerEl || !modalEl) {
      console.warn('[v-draggable] 未找到元素');
      return;
    }

    headerEl.style.cursor = 'move';

    const state: DragState = {
      isDragging: false,
      offsetX: 0,
      offsetY: 0,
      modalEl,
      headerEl,
    };

    const onMouseDown = (e: MouseEvent) => {
      if (e.button !== 0) return; // 只响应左键
      state.isDragging = true;

      const rect = modalEl!.getBoundingClientRect();
      state.offsetX = e.clientX - rect.left;
      state.offsetY = e.clientY - rect.top;

      e.preventDefault();
    };

    const onMouseMove = (e: MouseEvent) => {
      if (!state.isDragging || !modalEl) return;

      let x = e.clientX - state.offsetX;
      let y = e.clientY - state.offsetY;

      // === 边界限制 ===
      const vw = window.innerWidth;
      const vh = window.innerHeight;
      const modalRect = modalEl.getBoundingClientRect();

      x = Math.max(0, Math.min(x, vw - modalRect.width));
      y = Math.max(0, Math.min(y, vh - modalRect.height));

      // 设置为 fixed 定位
      modalEl.style.position = 'fixed';
      modalEl.style.margin = '0';
      modalEl.style.left = `${x}px`;
      modalEl.style.top = `${y}px`;
      modalEl.style.paddingBottom = '0';
    };

    const onMouseUp = () => {
      state.isDragging = false;
    };

    // 绑定事件
    headerEl.addEventListener('mousedown', onMouseDown);
    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', onMouseUp);

    // 👇重置谈框位置
    if (binding.value && typeof binding.value === 'function') {
      binding.value(() => {
        setTimeout(() => {
          if (modalEl) {
            modalEl.style.position = '';
            modalEl.style.left = '';
            modalEl.style.top = '';
            modalEl.style.margin = '';
          }
        }, 600);
      });
    }

    // 存储清理函数到 el 上，用于 unbind
    (el as any).__draggableCleanup = () => {
      headerEl.removeEventListener('mousedown', onMouseDown);
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', onMouseUp);
    };
  },

  unbind(el: HTMLElement) {
    const cleanup = (el as any).__cleanup;
    if (cleanup) cleanup();
  },
});

export default draggable;
